module.exports = __webpack_public_path__ + "img/bro.a79b70de.png";